import { Extension } from '@tiptap/core';

type StyleAttributeOptions = {
    types: string[];
};

const StyleAttribute = Extension.create<StyleAttributeOptions>({
    name: 'styleAttribute',

    addOptions() {
        return {
            types: [],
        };
    },

    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    style: {
                        default: null,
                        parseHTML: element => element.getAttribute('style') || null,
                        renderHTML: attributes => {
                            if (!attributes.style) {
                                return {};
                            }

                            return {
                                style: attributes.style,
                            };
                        },
                    },
                },
            },
        ];
    },
});

export default StyleAttribute;
